import { platformDelete, platformGet, platformPatch, platformPost } from './platformClient.js';

/**
 * Endpunkte der Anbieterebene.
 *
 * Hier steht ausdrücklich NICHTS, was Geschäftsdaten einer Kundenfirma
 * liefert. Der Anbieter verwaltet Firmen, er sieht ihre Zahlen nicht - das ist
 * nicht durch eine Prüfung gelöst, die man vergessen kann, sondern durch die
 * Abwesenheit jedes entsprechenden Aufrufs.
 */

export const platformAuthApi = {
  login: (email, password) => platformPost('/api/platform/auth/login', { email, password }),
  refresh: (refreshToken) => platformPost('/api/platform/auth/refresh', { refreshToken }),
  logout: (refreshToken) => platformPost('/api/platform/auth/logout', { refreshToken }),
  me: () => platformGet('/api/platform/auth/me').then((r) => r.items?.account),
};

export const tenantsApi = {
  list: (params) => platformGet('/api/platform/tenants', params),
  get: (id) => platformGet(`/api/platform/tenants/${id}`).then((r) => r.items),
  create: (payload) => platformPost('/api/platform/tenants', payload),
  update: (id, payload) => platformPatch(`/api/platform/tenants/${id}`, payload),
  /** Fortschritt der Einrichtung - die Antwort auf das Anlegen ist nur der Auftrag. */
  job: (jobId) => platformGet(`/api/platform/jobs/${jobId}`).then((r) => r.items),
  latestJob: (tenantId) => platformGet(`/api/platform/tenants/${tenantId}/job`).then((r) => r.items),

  /* Eigener Endpunkt statt PATCH status: das Sperren beendet zugleich JEDE
     laufende Sitzung der Firma. Über die allgemeine Änderung ginge das
     unter - und jemand mit gültigem Zugriffstoken könnte bis zu einer
     Viertelstunde weiterarbeiten. */
  setStatus: (id, status) => platformPost(`/api/platform/tenants/${id}/status`, { status }),

  /* Das Kürzel reist mit: der Server weist ab, wenn es nicht zur Firma
     passt. Ein Klick auf die falsche Zeile entfernt damit nicht die falsche
     Firma. */
  remove: (id, slug) => platformDelete(`/api/platform/tenants/${id}`, { slug }),
};

/** Benutzer einer Kundenfirma - vom Anbieter verwaltet. */
export const tenantUsersApi = {
  list: (tenantId) => platformGet(`/api/platform/tenants/${tenantId}/users`).then((r) => r.items.users),
  create: (tenantId, payload) => platformPost(`/api/platform/tenants/${tenantId}/users`, payload),
  update: (tenantId, userId, payload) =>
    platformPatch(`/api/platform/tenants/${tenantId}/users/${userId}`, payload),
  resetPassword: (tenantId, userId) =>
    platformPost(`/api/platform/tenants/${tenantId}/users/${userId}/reset-password`, {}),
};

export const demoRequestsApi = {
  list: (params) => platformGet('/api/platform/demo-requests', params),
  setStatus: (id, status) => platformPatch(`/api/platform/demo-requests/${id}`, { status }),
};

export const platformAuditApi = {
  // Was der Anbieter an einer Firma getan hat. Nicht zu verwechseln mit dem
  // Protokoll IN einer Kundeninstallation, an das hier niemand herankommt.
  list: (params) => platformGet('/api/platform/audit', params),
};
